import React from 'react'
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer } from 'recharts';
import { H2 } from '@blueprintjs/core'

const AgeBars = ({ data }) => {

    return (
        <div className='margin-top-large margin-bottom-large'>
            <H2 className='text-center margin-top-large new-results'>Tranche d'âge des votants selon l'indice d'ouverture <br /> R+5 à gauche - R+1 à droite</H2>
            <div className='margin-top-large margin-bottom-large'>
                <ResponsiveContainer width="100%" height={300}>
                    <BarChart width={900} height={300} data={data}
                        margin={{ top: 20, right: 30, left: 20, bottom: 5 }}>
                        <CartesianGrid strokeDasharray="3 3" />
                        <XAxis dataKey="name" />
                        <YAxis label="Votes % &emsp;&emsp;&emsp;" />
                        <Tooltip formatter={(value) => value === 0 ? '-' : `${value.toFixed(2)} %`} />
                        <Bar dataKey="< 20 R+5" stackId="a" fill="#1F77B4" />
                        <Bar dataKey="20-29 R+5" stackId="a" fill="#FF7F0E" />
                        <Bar dataKey="30-39 R+5" stackId="a" fill="#2CA02C" />
                        <Bar dataKey="40-49 R+5" stackId="a" fill="#D62728" />
                        <Bar dataKey="50-59 R+5" stackId="a" fill="#9467BD" />
                        <Bar dataKey="60-69 R+5" stackId="a" fill="#8C564B" />
                        <Bar dataKey="> 70 R+5" stackId="a" fill="#E377C2" />

                        <Bar dataKey="< 20 R+1" stackId="b" fill="#1F77B4" />
                        <Bar dataKey="20-29 R+1" stackId="b" fill="#FF7F0E" />
                        <Bar dataKey="30-39 R+1" stackId="b" fill="#2CA02C" />
                        <Bar dataKey="40-49 R+1" stackId="b" fill="#D62728" />
                        <Bar dataKey="50-59 R+1" stackId="b" fill="#9467BD" />
                        <Bar dataKey="60-69 R+1" stackId="b" fill="#8C564B" />
                        <Bar dataKey="> 70 R+1" stackId="b" fill="#E377C2" />


                    </BarChart>
                </ResponsiveContainer>
                <div className='ageLegends margin-top-large'>
                    <div className="ageLegend" style={{ backgroundColor: "#1F77B4" }}>Moins de 20</div>
                    <div className="ageLegend" style={{ backgroundColor: "#FF7F0E" }}>20 à 29</div>
                    <div className="ageLegend" style={{ backgroundColor: "#2CA02C" }}>30 à 39</div>
                    <div className="ageLegend" style={{ backgroundColor: "#D62728" }}>40 à 49</div>
                    <div className="ageLegend" style={{ backgroundColor: "#9467BD" }}>50 à 59</div>
                    <div className="ageLegend" style={{ backgroundColor: "#8C564B" }}>60 à 69</div>
                    <div className="ageLegend" style={{ backgroundColor: "#E377C2" }}>Plus de 70</div>
                </div>
            </div>
        </div>
    )
}

export default AgeBars

